import styled from 'styled-components/macro'

const UnlockedIcon = styled('i')`
  margin-left: 25px;
  margin-bottom: 10px;
  font-size: 75px;
  color: #fff;
`

export default UnlockedIcon
